import styled from 'styled-components';
import Button from 'bit/mobiauto.web-ui-components.components.button/Button';

export const ButtonTheme = styled(Button)`
  background: ${({ theme }) => theme.primary} !important;
  text-transform: initial !important;
`;
